<!-- 图组纪实·缅怀英烈 -->
<template>
  <div class="component-news-list">
    <div class="all-content">
      <div class="title">
        <div class="bigtitle">
          <span class="titlestyle">图组纪实·缅怀英烈</span>
        </div>
      </div>
      <div class="bigimg">
        <!-- 轮播 -->
        <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
          <swiper-slide
            class="slide"
            v-for="(item, index) in mhyl"
            :key="index"
          >
            <div class="image">
              <!-- <a
                :href="
                  'http://yinglie.chinamartyrs.gov.cn/zhylw/zcfg/content.html?id=' +
                    item.basicId
                "
                target="_blank"
              > -->
              <img :src="item.basicThumbnail" />
              <div class="imgtitles def-hover-trs">{{ item.basicTitle }}</div>
              <!-- </a> -->
            </div>
          </swiper-slide>

          <!-- <swiper-slide
              v-for="(item, index) in swiperList"
              :key="index"
              class="slide"
            >
              <router-link
                :to="{ path: '/news-details', query: { id: item.basicId } }"
                class="slide-item-content"
                target="_blank"
              >
                <el-image :src="item.basicThumbnail" class="image">
                  <div slot="error">
                    <img src="../assets/images/6.png" />
                  </div>
                </el-image>
              </router-link>
            </swiper-slide> -->
        </swiper>
        <!-- swiper轮播图圆点 -->
        <div class="swiper-pagination"></div>
      </div>
      <div class="smallimg">
        <!-- <i class="swiper-btn swiper-btn-prev el-icon-arrow-left" />
        <i class="swiper-btn swiper-btn-next el-icon-arrow-right" /> -->

        <div class="swiper-box">
          <swiper
            :options="swiperOptionThumbs"
            class="gallery-thumbs"
            ref="swiperThumbs"
          >
            <swiper-slide
              class="slide"
              v-for="(item, index) in mhyl"
              :key="index"
            >
              <div class="image">
                <img :src="item.basicThumbnail" />
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <!-- 左右切换按钮 -->
        <i class="swiper-btn swiper-btn-prev el-icon-arrow-left" />
        <i class="swiper-btn swiper-btn-next el-icon-arrow-right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComponentNewsList",
  components: {},
  props: ["mhyl"],
  computed: {},
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper;
      const swiperThumbs = this.$refs.swiperThumbs.$swiper;

      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;
    });
  },
  data() {
    return {
      // 图组纪实·缅怀英烈轮播图配置项
      swiperOptionTop: {
        loop: true,
        slidesPerView: 1, // 设置同时显示的slides数量
        spaceBetween: 11, // 在slide之间设置距离（单位px）
        loopedSlides: 4,
        grabCursor: true,
        speed: 2000, //速度
        autoplay: true, //自动切换
        autoplay: {
          delay: 4000, //自动切换的时间间隔，单位ms
          disableOnInteraction: false //用户操作swiper之后，是否禁止autoplay
        }
      },
      // 图组纪实·缅怀英烈轮播图配小图
      swiperOptionThumbs: {
        loop: true,
        slidesPerView: 4, // 设置同时显示的slides数量
        spaceBetween: 11, // 在slide之间设置距离（单位px）
        loopedSlides: 4,
        watchSlidesVisibility: true, //防止不可点击
        touchRatio: 0.2,
        slideToClickedSlide: true,
        // 配置左右切换按钮
        navigation: {
          prevEl: ".smallimg .swiper-btn-prev",
          nextEl: ".smallimg .swiper-btn-next"
        }
      }
    };
  }
};
</script>

<!-- 组件独有样式 -->
<style scoped>
/* 图片标题 */
.imgtitles {
  position: absolute;
  bottom: 5px;
  color: #fff;
  height: 50px;
  line-height: 50px;
  width: 100%;
  font-size: 21.34px;
  padding-left: 35px;
  background: rgb(0, 0, 0, 0.3);
}
.imgtitles:hover {
  color: var(--main-color);
}
.component-news-list {
  width: 1200px;
  min-width: 1200px;
  height: 1090px;
  background-color: rgb(255, 255, 255);
  border-radius: 15px;
  margin-top: 18px;
}
.all-content {
  width: 1140px;
  height: 440px;
  position: relative;
  margin: 0 auto;
  top: 30px;
}
.title,
.bigimg,
.smallimg {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.title {
  line-height: 15px;
}
.bigimg {
  /* height: 762px; */
  top: 40px;
  /* background-color: rgb(168, 192, 192); */
}
.bigimg img {
  width: 1143px;
  height: 762px;
}

.smallimg {
  top: 60px;
}
.smallimg .swiper-btn-prev {
  left: 0;
}

.smallimg .swiper-btn-next {
  right: 0;
}
.smallimg .swiper-btn {
  width: 36px;
  height: 171px;
  position: absolute;
  z-index: 10;
  background-color: #c4c1be;
  text-align: center;
  line-height: 165px;
  top: 25px;
  margin-top: -25px;
  color: #ffffff;
  font-size: 24px;
  cursor: pointer;
  transition: all 0.4s;
}

.smallimg .swiper-btn:hover {
  background-color: #a8151a;
}
.smallimg img {
  width: 256px;
  height: 171px;
}

.swiper-box {
  flex: 1;
  width: 1063px;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}

.swiper-box .swiper {
  height: 100%;
  /* background-color: #dedede; */
}

.swiper-box .slide {
  width: 2560px;
  height: 100%;
  /* background-color: #343434; */
}

.swiper-box .slide-item-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: block;
}

.swiper-box .image {
  width: 100%;
  height: 100%;
  display: block;
  transition: all 0.4s;
}

.swiper-box .image:hover {
  transform: scale(1.06);
}
/* 小图样式 */
.swiper-slide {
  cursor: pointer;
  background-size: cover;
  background-position: center;
}
.gallery-top {
  height: 80% !important;
  width: 100%;
}
.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
}
.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/mianhuai.vue